import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Heart, Moon, Sun } from "lucide-react";
import { Logo } from "./brand/Logo";
import { useTheme } from "../lib/theme";
import { useFavourites } from "../lib/favourites";

const LINKS = [
  { to: "/", label: "Home", id: "nav-link-home" },
  { to: "/pulse", label: "Community Pulse", id: "nav-link-pulse" },
  { to: "/volunteer", label: "Volunteer", id: "nav-link-volunteer" },
  { to: "/fundraisers", label: "Fundraisers", id: "nav-link-fundraisers" },
  { to: "/events", label: "Events", id: "nav-link-events" },
  { to: "/action-index", label: "Action Index", id: "nav-link-action-index" },
  { to: "/about", label: "About", id: "nav-link-about" },
];

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  const { count } = useFavourites();
  const [dark, toggleTheme] = useTheme();
  const cls = ({ isActive }) =>
    `rounded-full px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-sky-50 text-sky-900" : "text-slate-600 hover:text-sky-900 hover:bg-slate-50"}`;
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <Link to="/" data-testid="nav-brand" aria-label="RippleImpact home"><Logo size={34} textClass="text-lg sm:text-xl" /></Link>
        <span className="hidden text-xs font-semibold text-emerald-700 2xl:inline" data-testid="nav-tagline">Be the Change.</span>
        <div className="hidden items-center gap-0.5 lg:flex">
          {LINKS.map((l) => <NavLink key={l.to} to={l.to} end={l.to !== "/volunteer"} className={cls} data-testid={l.id}>{l.label}</NavLink>)}
        </div>
        <button onClick={toggleTheme} aria-label={dark ? "Switch to light mode" : "Switch to dark mode"} data-testid="theme-toggle" className="ml-auto rounded-full p-2 text-slate-600 hover:text-sky-900 lg:ml-0">
          {dark ? <Sun size={19} /> : <Moon size={19} />}
        </button>
        <Link to="/volunteer?view=saved" data-testid="nav-saved-link" aria-label={`Saved items: ${count}`} className="relative mr-2 rounded-full p-2 text-slate-600 hover:text-rose-500">
          <Heart size={20} />
          {count > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-semibold text-white" data-testid="nav-saved-count">{count}</span>}
        </Link>
        <Link to="/volunteer" data-testid="header-volunteer-cta" className="hidden rounded-full bg-sky-900 px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-sky-800 xl:inline-flex">
          Create a Ripple
        </Link>
        <button className="rounded-lg p-2 text-slate-700 lg:hidden" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      {open && (
        <div className="flex flex-col gap-1 border-t border-slate-100 bg-white px-5 py-3 lg:hidden" data-testid="mobile-menu">
          {LINKS.map((l) => <NavLink key={l.to} to={l.to} end={l.to !== "/volunteer"} className={cls} onClick={() => setOpen(false)} data-testid={`mobile-${l.id}`}>{l.label}</NavLink>)}
        </div>
      )}
    </header>
  );
};
